import { AppConst } from 'constants/appConst';

import DashboardLayoutNavbarLogout from 'components/layout/dashboardLayoutNavbarLogout/DashboardLayoutNavbarLogout';
import DashboardLayoutNavbarPlan from 'components/layout/dashboardLayoutNavbarPlan/DashboardLayoutNavbarPlan';
import { useState, type JSX } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAtom } from 'jotai';
import { AcctState } from 'stores/atoms/acctState';
import { ChatState } from 'stores/atoms/chatState';
import { NavbarState } from 'stores/atoms/navbarState';
import WsModalCompanySwitch from 'pages/ws/components/layout/layoutNavbar/WsModalCompanySwitch';
import { getCompanyImageUrl } from 'utils/app';

/**
 * 共通コンポーネント サイドメニュー
 */
export default function WsLayoutNavbar(): JSX.Element {
  /* ----------------------------------------------------------------------- */
  /* 変数定義 */
  /* ----------------------------------------------------------------------- */
  const navigate = useNavigate();

  const [acctState] = useAtom(AcctState);
  const [navbarState, setNavbarState] = useAtom(NavbarState);
  const [chatState] = useAtom(ChatState);

  const [companySwitchModalOpenState, setCompanySwitchModalOpenState] = useState(false);

  /* ----------------------------------------------------------------------- */
  /* イベントハンドラ関数定義 */
  /* ----------------------------------------------------------------------- */
  /**
   * メニューリンククリック時の処理
   */
  const onNavigate = (path: string) => {
    // スマートフォン表示の場合はサイドバーを閉じる
    if (navbarState.open) {
      setNavbarState({ open: false });
    }
    navigate(path);
  };

  /* ----------------------------------------------------------------------- */
  /* プライベート関数定義 */
  /* ----------------------------------------------------------------------- */

  /* ----------------------------------------------------------------------- */
  /* JSX */
  /* ----------------------------------------------------------------------- */
  return (
    <>
      <div
        id="navbar-white"
        className={`col-sidebar ${navbarState.open ? 'show' : ''} ${
          chatState.open ? 'hidden-by-chat' : ''
        }`}
      >
        <div className="col-sidebar-top">
          <h1 className="mb-0">
            <img
              src={acctState.proxyLogin ? '/img/common/logo-proxy.svg' : '/img/common/logo.svg'}
              alt="BranQ ブランク"
              className="logo d-block"
            />
          </h1>
          <ul className="list-unstyled list-menu">
            <li>
              <a onClick={() => onNavigate(`/ws/${acctState.company.cd}`)}>
                <span className="img-container mb-0">
                  <img src="/img/icon/home.svg" alt="ホーム" />
                </span>
                <span className="caption">ホーム</span>
              </a>
            </li>
            <li>
              <a onClick={() => onNavigate(`/ws/${acctState.company.cd}/content/search`)}>
                <span className="img-container">
                  <img src="/img/icon/list.svg" alt="コンテンツ" />
                </span>
                コンテンツ
              </a>
            </li>
            <li>
              <a onClick={() => onNavigate(`/ws/${acctState.company.cd}/respondent/search`)}>
                <span className="img-container">
                  <img src="/img/icon/stack.svg" alt="獲得リスト" />
                </span>
                獲得リスト
              </a>
            </li>
            <li>
              <a onClick={() => onNavigate(`/ws/${acctState.company.cd}/report/search`)}>
                <span className="img-container">
                  <img src="/img/icon/chart-gray.svg" alt="レポート" />
                </span>
                レポート
              </a>
            </li>
          </ul>
          <div className="text-center">
            <a onClick={() => setCompanySwitchModalOpenState(true)} className="btn btn-business">
              <div className="d-flex">
                <div className="flex-shrink-0 flex-img">
                  <img src={getCompanyImageUrl(acctState.company.imageKey)} />
                </div>
                <div className="flex-grow-1 flex-text caption">
                  <span className="">{acctState.company.name}</span>
                </div>
              </div>
            </a>
          </div>
        </div>
        <div className="col-sidebar-bottom">
          {/* 利用状況とプラン */}
          <DashboardLayoutNavbarPlan />

          <ul className="list-unstyled list-menu mb-0">
            <li>
              <a href={AppConst.url.support}>
                <span className="img-container">
                  <img src="/img/icon/question-gray.svg" alt="サポート" />
                </span>
                ヘルプサポート
              </a>
            </li>
            <li>
              <a onClick={() => onNavigate(`/setting/${acctState.company.cd}/profile`)}>
                <span className="img-container">
                  <img src="/img/icon/setting.svg" alt="設定" />
                </span>
                設定
              </a>
            </li>
          </ul>
          {/* ログアウトボタン */}
          <DashboardLayoutNavbarLogout />
        </div>
      </div>
      {/* カンパニー切り替えモーダル */}
      <WsModalCompanySwitch
        open={companySwitchModalOpenState}
        setOpen={setCompanySwitchModalOpenState}
      />
    </>
  );
}
